import {Pipe, PipeTransform} from '@angular/core';
import {UserProfileService} from '@ui-app/services/user-profile.service';

@Pipe({
    name: 'byRole'
})
export class ByRolePipe implements PipeTransform {
    constructor(private userProfileService: UserProfileService) {
    }

    transform(roles: number[], ...args: unknown[]): unknown {
        if (roles && roles.length) {
            // Check if userRoleId is passed as argument, otherwise use current user's role
            const userRoleId = args.length > 0 && args[0] !== undefined 
                ? args[0] as number 
                : this.userProfileService.user?.userRoleId;
                
            return roles.includes(userRoleId);
        } else {
            return true;
        }
    }

}
